import type {Fieldset} from 'components/customer/Product/entity/Fieldset';
import {useField} from 'formik';
import {useEffect, useState} from 'react';

export const useDrawerAmount = (fieldset: Fieldset) => {
    const [{value}] = useField<number>({name: 'drawer_amount'});

    const [drawerAmount, setDrawerAmount] = useState(() => {
        if (fieldset?.hasOwnProperty('quantity')) return fieldset.quantity;
        else return 0;
    });

    useEffect(() => {
        if (fieldset?.options?.innerDrawer) {
            setDrawerAmount(value);
        }
    }, [value]);

    return {drawerAmount};
};
